<template>
  <div>
    <h1>Add profiles</h1>
    <p>There are {{userData.length}} users to add</p>
    <button type="button" name="button" v-on:click="addUsers()">Add users</button>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  data () {
    return {
      userData: [
        {
          employeeNumber: 53,
          firstName: 'Nolo',
          lastName: 'Letele',
          country: 'South Africa',
          email: 'Nolo.Letele@multichoice.co.za',
          department: 'General Management',
          company: 'MultiChoice South Africa'
        }
      ]
    }
  },
  methods: {
    addUsers: function () {
      for (var i = 0; i < this.userData.length; i++) {
        console.log(this.userData[i])
        WordpressRestAPI.createThinkTankUser({
          email: this.userData.email,
          password: '_B53;=vY-S3pBsrT',
          firstname: this.userData.firstname,
          lastname: this.userData.lastname,
          department: this.userData.department,
          country: this.userData.country,
          employeenumber: this.userData.employeeNumber,
          company: this.userData.company
        }, '_B53;=vY-S3pBsrT')
          .then(response => {
            console.log(response)
          })
          .catch(e => {
            console.error(e)
          })
      }
    }
  },
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/CreateProfiles.vue